const DEPOSIT_AMOUNT = Object.freeze({
  full: 'full_amount',
  half: 'half_amount',
  custom: 'custom_amount',
  empty: 'null',
});

// noinspection JSUnusedGlobalSymbols
export default DEPOSIT_AMOUNT;
